import React, { useEffect, useState } from "react";
import { MDBContainer } from "mdbreact";

import Banner from "../../../template/Banner";
import NewsCard from "../../../template/NewsCard";
import Pagination from "../../../template/Pagination";
import Loader from "../../../template/Loader";

import bannerImg from "../../../../assets/img/news/banner.jpg";

import api from "../../../../services/api";

import "./styles.css";

export default () => {
  const [data, setData] = useState(null);
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);

  const description = "Numquam aliquam quae vitae saepe! Harum deleniti";

  useEffect(() => {
    (async function fetchNewsData() {
      setLoading(true);

      try {
        const { data } = await api.get(`/posts?category=1&page=${page}`);

        if (data.success) {
          setData(data);
          setNewsData(data.posts);
        }
      } catch (error) {
        console.error(error.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [page]);

  return (
    <div className="news">
      <Banner title="NOTÍCIAS" subtitle={description} img={bannerImg} />

      <MDBContainer className="content">
        <p className="text-intro">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil ducimus
          tempora magnam necessitatibus porro, cupiditate illo perspiciatis
          commodi placeat doloribus eum rerum inventore. Itaque, recusandae
          tenetur facere nobis culpa minima. Lorem ipsum dolor sit amet
          consectetur adipisicing elit. Nihil ducimus tempora magnam
          necessitatibus porro, cupiditate illo perspiciatis commodi placeat
          doloribus eum rerum inventore. Itaque, recusandae tenetur facere nobis
          culpa minima.
        </p>
      </MDBContainer>
      <MDBContainer>
        {loading ? (
          <Loader />
        ) : (
          <div className="my-5">
            {newsData.map((item) => (
              <NewsCard
                key={item.id}
                img={item.image_url}
                date={item.date}
                author={item.author}
                title={item.title}
                subtitle={item.description}
                path={`/nossa-atuacao/noticias/${item.slug}`}
              />
            ))}

            {data && data.total_page > 1 && (
              <Pagination
                setPage={setPage}
                page={page}
                totalPage={data.total_page}
              />
            )}
          </div>
        )}
      </MDBContainer>
    </div>
  );
};
